import { render, staticRenderFns } from "./NoticeMessageLayout.vue?vue&type=template&id=2a925c24&scoped=true&lang=pug&"
import script from "./NoticeMessageLayout.vue?vue&type=script&lang=ts&"
export * from "./NoticeMessageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeMessageLayout.vue?vue&type=style&index=0&id=2a925c24&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a925c24",
  null
  
)

export default component.exports